var _style, _g, _ellipse, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlnatilla(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72.5 72.3",
    style: {
      enableBackground: "new 0 0 72.5 72.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:none;stroke:#F47B33;stroke-width:2;}\r\n\t.st2{fill:#FFDFCC;}\r\n\t.st3{fill:#F47B33;}\r\n\t.st4{fill:#C65A1B;}\r\n\t.st5{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_47"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 36.5,
    cy: 36.6,
    rx: 35,
    ry: 35.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 36.5,
    cy: 36.6,
    rx: 34,
    ry: 34.5
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_46",
    className: "st2",
    cx: 36,
    cy: 36.6,
    rx: 29.5,
    ry: 30.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_566",
    transform: "translate(-140.164 -404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_47-2",
    transform: "translate(140.164 404)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 36.5,
    cy: 36.6,
    rx: 35,
    ry: 35.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 36.5,
    cy: 36.6,
    rx: 34,
    ry: 34.5
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_46-2",
    className: "st2",
    cx: 176.1,
    cy: 440.6,
    rx: 29.5,
    ry: 30.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "scroll",
    transform: "translate(159.508 424.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_274",
    className: "st3",
    d: "M27.1,1.6H5.1v0c1.4,0,2.6,1.2,2.6,2.6v24.5c0,1.7,1.4,3.1,3.1,3.1c0,0,0,0,0,0 c1.4,0,2.6-1.2,2.6-2.6v-2.7c0-0.5,0.4-1,1-1h15.2V4.2C29.7,2.7,28.5,1.6,27.1,1.6L27.1,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_275",
    className: "st3",
    d: "M31.3,25.6H14.5c-0.5,0-1,0.4-1,1l0,0v2.7c0,1.4-1.2,2.6-2.6,2.6h18.8 c1.4,0,2.6-1.2,2.6-2.6v-2.7C32.3,26,31.8,25.6,31.3,25.6L31.3,25.6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_523",
    transform: "translate(24.005 0.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_276",
    className: "st4",
    d: "M3.1,1.1H1.5c1.4,0,2.6,1.2,2.6,2.6c0,0,0,0,0,0v21.4h1.6V3.7C5.7,2.2,4.5,1.1,3.1,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_277",
    className: "st4",
    d: "M7.3,25.1H5.7c0.5,0,1,0.4,1,1l0,0v2.7c0,1.4-1.2,2.6-2.6,2.6h1.6c1.4,0,2.6-1.2,2.6-2.6 V26C8.3,25.5,7.8,25.1,7.3,25.1L7.3,25.1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_278",
    className: "st3",
    d: "M7.7,4.2c0-1.4-1.2-2.6-2.6-2.6v0H4.9C3.4,1.5,2.1,2.5,2,4c0,0.1,0,0.1,0,0.2v3.7 c0,0.5,0.4,1,1,1c0,0,0,0,0,0h4.8V4.2L7.7,4.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_524",
    transform: "translate(0.534 0.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_279",
    className: "st5",
    d: "M8.8,28.2V3.7c0-1.4-1.2-2.6-2.6-2.6v0H4.6v0c1.4,0,2.6,1.2,2.6,2.6v24.5 c0,1.7,1.4,3.1,3.1,3.1c0.2,0,0.5-0.1,0.7-0.1C9.7,30.8,8.8,29.6,8.8,28.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_280",
    className: "st5",
    d: "M3.1,7.4V3.7c0-1.2,0.9-2.3,2.1-2.5C5,1.1,4.8,1.1,4.6,1.1v0H4.4C2.9,0.9,1.6,2,1.5,3.5 c0,0.1,0,0.1,0,0.2v3.7c0,0.5,0.4,1,1,1c0,0,0,0,0,0H4C3.5,8.4,3.1,7.9,3.1,7.4C3.1,7.4,3.1,7.4,3.1,7.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_525",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_281",
    d: "M13.2,31.3h16.5c1.1,0,2.1-0.9,2.1-2.1v-2.7c0-0.2-0.2-0.5-0.5-0.5H14.5c-0.2,0-0.5,0.2-0.5,0.5v2.7 C14,30,13.7,30.8,13.2,31.3L13.2,31.3z M10.9,32.4c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5c1.2,0,2.1-0.9,2.1-2.1v-2.7 c0-0.8,0.7-1.5,1.5-1.5h16.8c0.8,0,1.5,0.7,1.5,1.5v2.7c0,1.7-1.4,3.1-3.1,3.1L10.9,32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_282",
    d: "M10.9,32.4c-2,0-3.7-1.6-3.7-3.6c0,0,0,0,0,0V17.2c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5 c0,0,0,0,0,0v11.5c0,1.4,1.2,2.6,2.6,2.6c1.1,0,2.1-0.9,2.1-2.1v-2.7c0-0.8,0.7-1.5,1.5-1.5h14.7V4.2c0-1.2-0.9-2.1-2.1-2.1H7.4 C8,2.7,8.3,3.4,8.3,4.2v8.9c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5V4.2c0-1.2-1-2.1-2.1-2.1c-0.3,0-0.5-0.3-0.5-0.5 c0-0.3,0.2-0.5,0.5-0.5h21.9c1.7,0,3.1,1.4,3.1,3.1v21.4c0,0.3-0.2,0.5-0.5,0.5l0,0H14.5c-0.2,0-0.5,0.2-0.5,0.5v2.7 C14,30.9,12.6,32.3,10.9,32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_283",
    d: "M8.3,15.1c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5S8.3,14.9,8.3,15.1 L8.3,15.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_284",
    d: "M18.2,9.4h-5.7c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h5.7c0.3,0,0.5,0.2,0.5,0.5 C18.7,9.2,18.5,9.4,18.2,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_285",
    d: "M18.2,20.4h-5.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h5.7c0.3,0,0.5,0.2,0.5,0.5 S18.5,20.4,18.2,20.4L18.2,20.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_286",
    d: "M25.5,13.1h-13c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h13c0.3,0,0.5,0.2,0.5,0.5S25.8,13.1,25.5,13.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_287",
    d: "M25.5,16.7h-13c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h13c0.3,0,0.5,0.2,0.5,0.5 C26,16.5,25.8,16.7,25.5,16.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_288",
    d: "M4.9,2.1C3.7,2,2.7,2.8,2.5,4c0,0,0,0.1,0,0.1v3.7c0,0.2,0.2,0.5,0.5,0.5h4.2V4.2c0-1.2-1-2.1-2.1-2.1 c0,0,0,0-0.1,0L4.9,2.1z M7.7,9.4H3c-0.8,0-1.5-0.7-1.5-1.5V4.2C1.5,2.4,2.9,1,4.7,1c0.1,0,0.1,0,0.2,0h0.2c0.1,0,0.1,0,0.2,0 c1.6,0.1,2.9,1.4,3,3.1v4.7C8.3,9.2,8,9.4,7.7,9.4L7.7,9.4L7.7,9.4z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlnatilla);
export default __webpack_public_path__ + "static/media/plnatilla.dfa2957b.svg";
export { ForwardRef as ReactComponent };